import { map } from 'lodash';
import PropTypes from 'prop-types';
import React, { useMemo } from 'react';
import Label from '../../../shared/model/label/Label';
import { filterByProp } from '../../../shared/util/collection';
import LabelComponent from './Label';
import './Label.css';

const Labels = ({ labels, ids }) => {
  const labelsFiltered = useMemo(() => filterByProp(labels, ids, 'id', 'name'), [labels, ids]);
  if (!labelsFiltered) {
    return null;
  }
  return map(labelsFiltered, (label) => (
    <LabelComponent key={label.id} name={label.getName()} />
  ));
};

Labels.propTypes = {
  labels: PropTypes.arrayOf(PropTypes.instanceOf(Label)).isRequired,
  ids: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.string), PropTypes.string])
};

Labels.defaultProps = {
  labels: [],
  ids: []
};

export default Labels;
